export default function translate(i18n, propriete) {
  if (propriete === 'titre') {
    return i18n.t('sprint.addEdit.titre');
  }
  if (propriete === 'sprint') {
    return i18n.t('sprint.addEdit.sprint');
  }
  if (propriete === 'dateAffichage') {
    return i18n.t('sprint.addEdit.dateAffichage');
  }
  if (propriete === 'dateRetraitHomePage') {
    return i18n.t('sprint.addEdit.dateRetraitHomePage');
  }
  return propriete;
}
